import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { ROUTES, canAccessRoute, isChapeaExperience } from '../../helpers/accessControl';

import './Header.css';

function Header({ allowedRoutes, defaultRoute }) {
  const canAccess = (route) => canAccessRoute(allowedRoutes, route);
  // CHAPEA users get their page-links from the subheader dropdown, so the top-nav
  // Hardware/Convert Files links are suppressed for them (in every environment)
  // rather than keying off the build-time `config.mode`.
  const chapeaExperience = isChapeaExperience(allowedRoutes);
  return (
    <div className="navbar">
      <div className="left-navbar">
        <div role="button" className="navbar-item">
          <Link to={defaultRoute} className="app-title-link">
            HIPPO
          </Link>
        </div>
        <div className="navbar-item">
          <Link to={defaultRoute} className="app-description">
            <span className="app-description">Testing Environments</span>
          </Link>
        </div>
        {canAccess(ROUTES.HARDWARE) && !chapeaExperience
          ? (
            <div className="navbar-item">
              <Link to="/hardware" className="app-description">
                <span className="app-description">Hardware</span>
              </Link>
            </div>
          )
          : null}
        {canAccess(ROUTES.CONVERT_FILES) && !chapeaExperience ? (
          <div className="navbar-item">
            <Link to="/convert-files" className="app-description">
              <span className="app-description">Convert Files</span>
            </Link>
          </div>
        ) : null}
      </div>
    </div>
  );
}

Header.propTypes = {
  allowedRoutes: PropTypes.arrayOf(PropTypes.string),
  defaultRoute: PropTypes.string,
};

Header.defaultProps = {
  allowedRoutes: ['*'],
  defaultRoute: '/dashboard',
};

export default Header;
